import appSettings from '../app-settings.json';
import { BaseSender } from './base-sender.js';

export class AuthSender extends BaseSender {
  dataDomain = appSettings.strPlacerApiDomain;
}

export const authSender = new AuthSender();
